import { useState } from 'react';

import { DaysNumberInput } from '~/components/Sequence/DaysNumberInput';

/**
 * Compact "N days" editor shared by the timing steps — a `wait` duration and an `await_connect`
 * acceptance deadline. Edits locally while typing and commits (clamped to 1–365) on blur / Enter, so we
 * don't fire a save on every keystroke. The field mechanics (incl. Escape-cancels) live in
 * {@link DaysNumberInput}.
 */
export function DurationDaysInput({
  days,
  onCommit,
  autoFocus,
}: {
  days: number;
  onCommit: (days: number) => void;
  /** Focus + select the number field on mount — set when opened in a popover so it's ready to type. */
  autoFocus?: boolean;
}) {
  const [value, setValue] = useState(String(days));

  const commit = () => {
    const parsed = Math.round(Number(value));
    const next = Number.isFinite(parsed) ? Math.max(1, Math.min(365, parsed)) : days;
    setValue(String(next));
    if (next !== days) onCommit(next);
  };

  return (
    <div className="flex items-center gap-1.5" onClick={(e) => e.preventDefault()}>
      <DaysNumberInput value={value} onChange={setValue} onCommit={commit} min={1} max={365} autoFocus={autoFocus} className="w-16" />
      <span className="text-xs text-gray-500 dark:text-gray-400">day{Number(value) === 1 ? '' : 's'}</span>
    </div>
  );
}
